export const STUDENT_SORT_BY_ENUM = {
  FULL_NAME: "FULL_NAME",
  FIRST_NAME: "FIRST_NAME",
  LAST_NAME: "LAST_NAME",
};

export const STUDENT_ORDER_BY_ENUM = {
  A_Z: "A_Z",
  Z_A: "Z_A",
};

export const SORT_DROPDOWN_OPTIONS = t => [
  {
    isItemGroup: true,
    label: t("common:sort_by"),
    options: [
      {
        key: STUDENT_SORT_BY_ENUM.FULL_NAME,
        label: t("common:full_name"),
      },
      {
        key: STUDENT_SORT_BY_ENUM.FIRST_NAME,
        label: t("common:first_name"),
      },
      {
        key: STUDENT_SORT_BY_ENUM.LAST_NAME,
        label: t("common:last_name"),
      },
    ],
  },
  {
    isItemGroup: true,
    label: t("common:order"),
    options: [
      {
        key: STUDENT_ORDER_BY_ENUM.A_Z,
        label: t("common:a_to_z"),
      },
      {
        key: STUDENT_ORDER_BY_ENUM.Z_A,
        label: t("common:z_to_a"),
      },
    ],
  },
];

export const ORDER_BY_TO_DIRECTION_MAP = {
  [STUDENT_ORDER_BY_ENUM.A_Z]: "ASC",
  [STUDENT_ORDER_BY_ENUM.Z_A]: "DESC",
};
